<template>
  <div class="event-categories-container">
    <template v-if="allEventCategories && allEventCategories.length">
      <v-card
        v-for="category in allEventCategories"
        :key="category.id"
        class="event-category-card my-5"
      >
        <v-card-text>
          <div class="left">
            <pre>{{ category.name }}</pre>
          </div>
          <div class="event-category__actions">
            <v-btn class="ml-3" color="error" x-small fab @click="editCategory(category)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="ml-3" color="error" x-small fab @click="deleteCategory(category)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <p v-else>No existing event categories. Please add using the button above.</p>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['allEventCategories'])
  },
  methods: {
    ...mapMutations(['setGlobalNotification']),
    ...mapActions(['firestoreDeleteEventCategory']),

    editCategory (category) {
      this.$root.$emit('showEventCategoryEditor', category)
    },

    deleteCategory (category) {
      if (confirm(`Are you sure you want to delete the event category "${category.name}"?`)) {
        this.firestoreDeleteEventCategory(category.id)
      }
    }
  }
}
</script>

<style lang="scss">
.event-category-card {
  .v-card__text {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      gap: 12px;
    }
  }
}
</style>
